import { User } from '@spo/logic';
import './userButton.scss';

export type UserProps = {
  user: User | null;
};

export const UserButton = ({ user }: UserProps) => {
  return (
    <div data-testid="user_container" className="user-info-container">
      <div className="user-picture">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M5.33203 30.6665C5.33203 27.8375 6.45584 25.1244 8.45623 23.124C10.4566 21.1236 13.1697 19.9998 15.9987 19.9998C18.8277 19.9998 21.5408 21.1236 23.5412 23.124C25.5416 25.1244 26.6654 27.8375 26.6654 30.6665H23.9987C23.9987 28.5448 23.1558 26.5099 21.6556 25.0096C20.1553 23.5094 18.1204 22.6665 15.9987 22.6665C13.877 22.6665 11.8421 23.5094 10.3418 25.0096C8.84155 26.5099 7.9987 28.5448 7.9987 30.6665H5.33203ZM15.9987 18.6665C11.5787 18.6665 7.9987 15.0865 7.9987 10.6665C7.9987 6.2465 11.5787 2.6665 15.9987 2.6665C20.4187 2.6665 23.9987 6.2465 23.9987 10.6665C23.9987 15.0865 20.4187 18.6665 15.9987 18.6665ZM15.9987 15.9998C18.9454 15.9998 21.332 13.6132 21.332 10.6665C21.332 7.71984 18.9454 5.33317 15.9987 5.33317C13.052 5.33317 10.6654 7.71984 10.6654 10.6665C10.6654 13.6132 13.052 15.9998 15.9987 15.9998Z"
            fill="#001018"
          />
        </svg>
      </div>
      <div className="user-info">
        <p data-testid="welcome_user-name">{user?.username}</p>
        <p data-testid="welcome_user-mail">{user?.mail}</p>
      </div>
    </div>
  );
};
